var through = require('through')

var checkboxExp = /<input[\s\S]*?type="checkbox".*?>/gim
var radioExp = /<input[\s\S]*?type="radio".*?>/gim
var checkboxTransform =  function(x) {
	if(x.indexOf('non-standard-check') > -1) {
		return x
	}
	return x + '<svg>\
					<use xlink:href="#checkbox-inner-shadow"/>\
					<use class="unchecked-unfocused" xlink:href="#icon-checkbox-unchecked-unfocused"/>\
					<use class="unchecked-focused" xlink:href="#icon-checkbox-unchecked-focused"/>\
					<use class="checked-unfocused" xlink:href="#icon-checkbox-checked-unfocused"/>\
					<use class="checked-focused" xlink:href="#icon-checkbox-checked-focused"/>\
					<use class="checkmark" xlink:href="#checkbox-check"/>\
				</svg>'
}
var radioTransform =  function(x) {
	if(x.indexOf('non-standard-radio') > -1) {
		return x
	}
	return x + '<svg>\
					<use class="radio-unselected" xlink:href="#icon-radio"/>\
					<use class="radio-unselected-disabled" xlink:href="#icon-radio-unselected-disabled"/>\
					<use class="radio-hovered" xlink:href="#icon-radio-hover"/>\
					<use class="radio-selected" xlink:href="#icon-radio-selected"/>\
				</svg>'
}

var sb3BrowserifyTransform = function(file) {
	var data = ''
	var filename = file.toString()
	if(/\.hbs$/.test(filename)) {
		// ends with .hbs
		return through(write, end)
	}
	else {
		return through(write, noopEnd)
	}

	function write (buf) { data += buf }
	function end () {
		data = data.replace(checkboxExp, checkboxTransform)
		data = data.replace(radioExp, radioTransform)
		this.queue(data)
		this.queue(null)
	}

	function noopEnd () {
		this.queue(data)
		this.queue(null)
	}
}

module.exports = sb3BrowserifyTransform
module.exports.checkboxTransform = checkboxTransform
module.exports.checkboxExp = checkboxExp
module.exports.radioTransform = radioTransform
module.exports.radioExp = radioExp
